require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dolores-qui-consectetur-perspiciatis-quo.json") })
        }
      }, "path---dolores-qui-consectetur-perspiciatis-quo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dolores-qui-consectetur-perspiciatis-quo!./.cache/json/dolores-qui-consectetur-perspiciatis-quo.json
// module id = 394
// module chunks = 231608221292675